// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3WCfV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3tJfa"};